export var UnassignFromShiftUserType;
(function (UnassignFromShiftUserType) {
    UnassignFromShiftUserType["NURSE"] = "nurse";
    UnassignFromShiftUserType["CARESEND"] = "careSend";
})(UnassignFromShiftUserType || (UnassignFromShiftUserType = {}));
export var UnassignfromShiftReason;
(function (UnassignfromShiftReason) {
    UnassignfromShiftReason["UNRESPONSIVE"] = "unreponsive";
    UnassignfromShiftReason["LICENSE_ISSUES"] = "licenseIssues";
    UnassignfromShiftReason["CLINICIAN_CANCELATION"] = "clinicianCancelation";
    UnassignfromShiftReason["DEMAND_SIDE_PREFERENCE"] = "demandSidePreference";
    UnassignfromShiftReason["DISPATCH_MISTAKE"] = "dispatchMistake";
    UnassignfromShiftReason["MISSED_CHECKIN"] = "missedCheckIn";
})(UnassignfromShiftReason || (UnassignfromShiftReason = {}));
//# sourceMappingURL=shifts.js.map